import { useGetPublicPendudukStatistik } from '@tatatemplate/shared-lib'

/**
 * Envelope kontrak dipertahankan (tanpa `select`) — pemanggil di template ini membaca
 * `.data`, sama seperti hook lama yang memulangkan `ApiResponse<T>` utuh.
 */
export function usePendudukStats() {
  return useGetPublicPendudukStatistik({
    query: { queryKey: ['penduduk', 'statistics'], staleTime: 5 * 60 * 1000, retry: 3 },
  })
}
